import { ContentNodeUtils, FieldContentNode } from '@helo/cms'
import { Assert, pipe } from '@helo/utils'

import { Icon } from '../../../components/Icons/Icon'
import { Link } from '../../../components/Link/Link'
import { Tooltip } from '../../../components/Tooltip/Tooltip'
import { TypeRenderer } from '../../../datatypes/TypeRenderer'
import { CellRendererProps } from '../table.types'

interface TypeRendererCellProps
  extends CellRendererProps<string | number | null> {
  contentNode: FieldContentNode
  isCellHover?: boolean
}

export const TypeRendererCell = ({
  // value,
  contentNode,
  // colDef,
  isCellHover = true,
}: TypeRendererCellProps) => {
  const ofType = pipe(
    contentNode,
    Assert.orThrow(ContentNodeUtils.isKind('FIELD')),
    ContentNodeUtils.getOfType(),
    // ContentNodeUtils.setState([{ state: contentNode.state }]),
  )
  const state = ofType.state ?? {}
  const linkUrl = 'linkUrl' in state ? state.linkUrl : undefined
  const linkDisableTabIcon =
    'linkDisableTabIcon' in state ? state.linkDisableTabIcon : false
  const linkUrlStorage =
    'linkUrlStorage' in state ? state.linkUrlStorage : undefined

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <TypeRenderer
        // value={value as any}
        contentNode={ofType}
        // options={{ ...defaultOptions, ...colDef.options }}
        // context={colDef.context}
      />
      {linkUrl && !linkDisableTabIcon && isCellHover && (
        <Link to={linkUrl} search={linkUrlStorage} target="_blank">
          <Tooltip label="Open Link in New Tab" placement="top">
            <Icon
              icon="ExternalLinkIcon"
              color="presets.turquoise.60"
              boxSize="16px"
              marginTop="-4px"
            />
          </Tooltip>
        </Link>
      )}
    </div>
  )
}
